import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M14 7a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M14 17a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}],["path",{"d":"M10 12h3l2 -2.5","key":"svg-3"}],["path",{"d":"M15 14.5l-2 -2.5","key":"svg-4"}]]

const IconCurrencyRipple = createReactComponent('outline', 'currency-ripple', 'CurrencyRipple', __iconNode);

export default IconCurrencyRipple;